import { Box } from "@outschool/backpack";
import React from "react";

import { useStickyHeader } from "../../hooks/useStickyHeader";

const StickyHeaderConatiner = React.forwardRef<
  HTMLDivElement,
  { children: React.ReactNode }
>(({ children }, ref) => {
  const { enabled } = useStickyHeader();
  const headerContainerStyle = enabled
    ? {
        position: "sticky",
        top: 0,
        zIndex: 202,
        // improve rendering performance in Safari
        transform: "translateZ(0)",
        willChange: "transform",
        backfaceVisibility: "hidden"
      }
    : {};

  return (
    <Box ref={ref} sx={headerContainerStyle}>
      {children}
    </Box>
  );
});

export default StickyHeaderConatiner;
